interface FeeArrangementDTO {
  id?: string;
  workspaceId?: string;
  createdBy?: string;
  createdOn?: string;
  createdByName?: string;
  modifiedBy?: string;
  modifiedOn?: string;
  modifiedByName?: string;
  contractType: string;
  currency?: string;
  fee: number;
  feeType: string;
  serviceFeePeriod?: string;
  startDate: string;
  endDate: string;
  clientId: string;
  clientContactId?: string;
  feeArrangementLevel: string;
  isArchive?: boolean;
  comments?: string;
}

class FeeArrangementDTO {
  constructor(feeArrangementDTO: FeeArrangementDTO) {
    Object.assign(this, feeArrangementDTO);
  }
}

export default FeeArrangementDTO;
